import AllergiesIllnessesForm from "./AllergiesIllnessesForm";

export default AllergiesIllnessesForm;